module.exports = __webpack_public_path__ + "img/sx.fb4bad55.png";